/*
 * Menu samping (off-canvas) untuk layar kecil (< 992px), AzZahra CBT aplikasi lama.
 * Tombol menu header (.responsive-toggler) membuka/menutup sidebar dari kiri, bukan collapse ke bawah.
 * Gaya: assets/global/css/az-sidemenu.css
 */
(function () {
    // Penanda bahwa skrip aktif; CSS menu samping hanya berlaku dengan kelas ini.
    document.documentElement.classList.add('az-sidemenu');
    var BATAS = 992;
    var backdrop = null;
    var kecil = function () { return (window.innerWidth || document.documentElement.clientWidth) < BATAS; };

    function pastikanBackdrop() {
        if (backdrop || !document.body) return;
        backdrop = document.createElement('div');
        backdrop.className = 'az-sidemenu-backdrop';
        backdrop.addEventListener('click', tutup);
        document.body.appendChild(backdrop);
    }
    function buka() { pastikanBackdrop(); document.body.classList.add('az-sidemenu-open'); }
    function tutup() { document.body.classList.remove('az-sidemenu-open'); }
    function terbuka() { return document.body.classList.contains('az-sidemenu-open'); }

    // Capture di window: berjalan sebelum handler collapse BS5 di document.
    window.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var tog = t.closest('.responsive-toggler');
        if (tog) {
            if (!kecil()) return;
            e.preventDefault();
            e.stopPropagation();
            terbuka() ? tutup() : buka();
            return;
        }
        // Pilih menu tujuan (bukan pembuka sub-menu) -> tutup panel.
        if (terbuka()) {
            var a = t.closest('.page-sidebar-menu a');
            if (a) {
                var li = a.parentElement;
                var punyaSub = li && li.querySelector(':scope > .sub-menu');
                if (!punyaSub) setTimeout(tutup, 150);
            }
        }
    }, true);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && terbuka()) tutup(); });
    window.addEventListener('resize', function () { if (!kecil() && terbuka()) tutup(); });
    // Navigasi SPA (AngularJS ui-router) -> pastikan panel tertutup.
    window.addEventListener('popstate', tutup);
    window.addEventListener('hashchange', tutup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pastikanBackdrop); else pastikanBackdrop();
})();
